// LemonSqueezy configuration and helpers
const LS_STORE_ID = import.meta.env.VITE_LEMONSQUEEZY_STORE_ID || '';
const LS_CHECKOUT_URL = `https://${LS_STORE_ID}.lemonsqueezy.com/checkout/buy`;

export interface PricingPlan {
  id: string;
  name: string;
  description: string;
  price: number;
  priceId: string;
  credits: number;
  features: string[];
  popular?: boolean;
  billing?: string;
  trial?: number;
  originalPrice?: number;
}

export const PLANS: PricingPlan[] = [
  {
    id: 'free',
    name: 'Free',
    description: 'Migration fallback starter plan',
    price: 0,
    priceId: 'free',
    credits: 3000,
    billing: 'month',
    features: [
      '3,000 credits/month',
      '1 managed persona',
      '5 network people',
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    description: 'Migration fallback for professionals',
    price: 19,
    priceId: 'pro',
    credits: 50000,
    popular: true,
    billing: 'month',
    trial: 3,
    features: [
      '50,000 credits/month',
      '3-day trial',
      '5 managed personas',
      '50 network people',
      'AI Studio',
    ],
  },
  {
    id: 'agency',
    name: 'Agency',
    description: 'Migration fallback for teams',
    price: 49,
    priceId: 'agency',
    credits: 200000,
    billing: 'month',
    features: [
      '200,000 credits/month',
      '20 managed personas',
      '100 network people',
      'Priority support',
    ],
  },
];

export const CREDIT_PACKS = [
  { id: 'small', credits: 5000, price: 5, priceId: 'credits_5k' },
  { id: 'medium', credits: 15000, price: 12, priceId: 'credits_15k' },
  { id: 'large', credits: 50000, price: 35, priceId: 'credits_50k' },
];

export function createCheckoutUrl(priceId: string, customerEmail?: string): string {
  const params = new URLSearchParams();
  params.append('variant', priceId);
  if (customerEmail) {
    params.append('checkout[email]', customerEmail);
  }
  return `${LS_CHECKOUT_URL}?${params.toString()}`;
}

export function openCheckout(priceId: string, customerEmail?: string) {
  const url = createCheckoutUrl(priceId, customerEmail);
  window.open(url, '_blank', 'width=600,height=700');
}
